export default "__VITE_ASSET__CUAkrjMQ__"